import styled from "styled-components"

export const SubtotalWrapper = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.text.light};
  padding: 5px 0;
`

export const Attribute = styled.span`
  font-weight: 600;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
`
